module.exports = __webpack_public_path__ + "media/images/officer-icon-782575392b2214046beeea668f7c7d82.svg";